import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  LearningProgress,
  LearningProgressMeta,
  LearningProgressSummary,
} from '../Types/ProgressTypes';

export type LearningProgressState = {
  studentsProgress: Array<LearningProgress>;
  inProgress: boolean;
  meta: LearningProgressMeta;
  summary: LearningProgressSummary | null;
  inProgressSummary: boolean;
};

export const LearningProgressInitState = {
  studentsProgress: [],
  inProgress: false,
  meta: {
    totalItems: 0,
    currentPage: 0,
    pages: 0,
    perPage: 0,
  },
  summary: null,
  inProgressSummary: false,
} as LearningProgressState;

const learningProgressSlice = createSlice({
  name: 'learningProgress',
  initialState: LearningProgressInitState,
  reducers: {
    getLearningProgressSuccess(
      state,
      action: PayloadAction<{
        meta: LearningProgressMeta;
        studentProgress: Array<LearningProgress>;
      }>
    ) {
      state.studentsProgress = action.payload.studentProgress;
      state.meta = action.payload.meta;
    },
    fetchLearningInProgressStart(state) {
      state.inProgress = true;
    },
    fetchLearningInProgressFinish(state) {
      state.inProgress = false;
    },
    getLearningProgressSummarySuccess(
      state,
      action: PayloadAction<LearningProgressSummary>
    ) {
      state.summary = action.payload;
    },
    fetchLearningInProgressSummaryStart(state) {
      state.inProgressSummary = true;
    },
    fetchLearningInProgressSummaryFinish(state) {
      state.inProgressSummary = false;
    },
    resetLearningProgressState(state) {
      const { inProgress, studentsProgress, meta, inProgressSummary, summary } =
        LearningProgressInitState;

      state.inProgress = inProgress;
      state.studentsProgress = studentsProgress;
      state.meta = { ...meta };
      state.inProgressSummary = inProgressSummary;
      state.summary = summary;
    },
  },
});

export const {
  getLearningProgressSuccess,
  fetchLearningInProgressStart,
  fetchLearningInProgressFinish,
  resetLearningProgressState,
  getLearningProgressSummarySuccess,
  fetchLearningInProgressSummaryStart,
  fetchLearningInProgressSummaryFinish,
} = learningProgressSlice.actions;
export const learningProgressReducer = learningProgressSlice.reducer;
